import createAccountOverviewPagesService from "./factory";

export default createAccountOverviewPagesService();
